export default __webpack_public_path__ + "static/media/3d.8b10c657.png";